import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import FeaturesSection from "./FeaturesSection";
import UpdatesSection from "./UpdatesSection";
const FlowRead = () => {
  return (
    <>

<Navbar></Navbar>
<div className="page-container">
  {/* Overview Section */}
  <section id="overview" className="section-main section-blue">
    <h1>FlowRead: Learn Smarter, Read Better</h1>
    <p>Want to learn a new language or explore new knowledge but don’t know where to start?  
    FlowRead helps you **organize your reading journey** with curated booklists and structured learning paths.</p>
  </section>

  {/* Features Section */}
  <FeaturesSection></FeaturesSection>

  {/* Updates Section */}
  <UpdatesSection></UpdatesSection>

  {/* Contact Us */}
  <section id="contact" className="section-contact">
    <h2>Contact Us</h2>
    <p>Have feedback or questions? Reach us at sunev@sunev.xyz!</p>
  </section>

  {/* Privacy Policy */}
  <section id="privacy" className="section-privacy section-light-gray">
    
    <li><Link to="/FlowRead/privacypolicies">Privacy Policy</Link></li>
    
  </section>
</div>

    </>
  );
};

export default FlowRead;
